import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { TdcApplicationEvaluation } from 'src/app/models/tdc/tdc-evaluation.model';

export const TdcAplicationActions = createActionGroup({
	source: 'TdcApplication',
	events: {
		'Add Tdc Application': props<TdcApplicationEvaluation>(),
		'Add Has Save Debit Card Option': emptyProps(),
	},
});
